<template>
  <div>
    
  </div>
</template>

<script>
import { introduce } from '@/api/mall/mallShop'
export default {
  props: {
    title: {
      required: false,
    }
  },
  data() {
    return {
      name: '',
      tit: '',
    }
  },
  watch: {
    title: {
      handler(newData, oldData) {
        if(newData){
          this.tit = newData
          this.titleChange()
        }
      },
      deep:true,
      immediate: true
    },
  },
  created() {
    if(this.$route.query.shopId){
      this.getShopInfo()
    }
  },
  methods: {
    // 获取店铺信息
    getShopInfo(){
      let req = {shopId: this.$route.query.shopId}
      introduce(req).then(res=>{
        if(res.code===200){
          this.name = res.data.shopName
          if(this.name){
            this.name += ' - '
          }
          this.titleChange()
        }
      })
    },
    titleChange(){
      document.title = this.name + this.tit
    },
  }
}
</script>

<style lang="less" scoped>

</style>